<template>
	<div class="deal_box">
		<!-- 标题 -->
		<div class="deal_record">
			<div>
				<h3>最近一周銷售金額</h3>
				<p>{{list.money}}</p>
			</div>
			<div>
				<h3>最近一周銷售筆數</h3>
				<p>{{list.count}}</p>
			</div>
			<div>
				<h3>每筆平均金額</h3>
				<p>{{list.pj_money}}</p>
			</div>
		</div>
		<!-- 表格 -->
		<div class="deal_table list_top">
			<div id="myChart" :style="{width: '100%', height: '400px'}"></div>
			<!-- <img src="@/assets/img/common/xxxx.png" alt=""> -->
		</div>
		<!-- 品宣 -->
		<div class="deal_banner">
			<img src="@/assets/img/common/banner.jpg" alt="" style="width: 100%">
		</div>
		<!--  -->
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'Deal',
		props: [
			'list'
		],
		data() {
			return {
				msg: 'Welcome to Your Vue.js App'
			}
		},
		mounted() {
			this.drawLine();
		},
		methods: {
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				var myChart = this.$echarts.init(document.getElementById('myChart'))
				// 绘制图表
				myChart.setOption({
					title: {
						text: '',
						subtext: ''
					},
					grid: {
						x: 45,
						y: 65,
						x2: 45,
						y2: 50,
						borderWidth: 1
					},

					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['交易筆數']
					},
					toolbox: {
						show: true,
					},
					xAxis: {
						splitLine: {
							show: true
						},
						type: 'category',
						boundaryGap: false,
						data: ['2019-07-5', '2019-07-6', '2019-07-7', '2019-07-8', '2019-07-9', '2019-07-10', '2019-07-11'],
						axisLabel: {
							show: true,
							textStyle: {
								color: '#000' //x轴data 的颜色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#e7e7eb', //x轴颜色 
							}
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: '{value}筆 '
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#000' //x轴data 的颜色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#e7e7eb', //x轴颜色 
							}
						}
					},
					series: [{
						color: 'rgba(109, 218, 109, 1)',
						symbolSize: 5,
						width: 3,
						name: '交易筆數',
						type: 'line',
						data: [0, 11, 3, 13, 7, 13, 5],
						markPoint: {
							data: [{
									type: 'max',
									name: '交易筆數最大'
								},
								{
									type: 'min',
									name: '交易筆數最小'
								}
							]
						},
						markLine: {
							data: [{
								type: 'average',
								name: '平均值',
								symbol: 'circle',
							}]
						}
					}]
				})
			},
			amendAxFun() {
				axios.get(this.$store.state.axiosLoginUrl, {
					params: {
						uid: this.$store.state.uid,
						action: 1,
					}
				}).then((res) => {
					if (res.data.status) {
						var myChart = this.$echarts.init(document.getElementById('myChart'))
						myChart.setOption({
							xAxis: {
								data: res.data.message[4]
							},
							series: [{
								// 根据名字对应到相应的系列
								name: '交易筆數',
								data: res.data.message[5]
							}]
						});
					} else {
						this.$message({
							showClose: true,
							message: res.data.message,
							type: 'error',
							duration: 1000
						});
					}

				})

			},
		},

		components: {

		},
		created() {
			this.amendAxFun();
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.deal_box {
		margin-top: 32px;
		overflow: hidden;
	}

	/* 标题 */
	.deal_record {
		font-size: 29px;
		text-align: right;
		font-weight: bold;
		color: black;
		display: flex;
		justify-content: space-around;
	}

	.deal_record h3 {
		font-weight: bold;
	}

	.deal_record p {
		color: #e73262;
		margin-top: 26px;
	}

	/* 表格-占位，还没做 */
	.deal_table img {
		width: 840px;
	}

	/* 品宣 */
	.deal_banner {
		width: 860px;
		height: 200px;
		background: #87aa83;
		font-size: 40px;
	}

	.list_top {
		padding-top: 15px;
	}
</style>
